import ApiConfig from "../../config/ApiConfig";
import { getEndpointBuilder } from "./getEndpointBuilder";

export const getParametizedQuoteEndpoint = (lookingTo, data) => {
  const baseUrl = new URL(
    ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint
  );

  const endpointBuilder = getEndpointBuilder(lookingTo);

  return endpointBuilder({
    baseUrl,
    data,
    lookingTo,
  });
};
